import React from 'react';

import cx from 'clsx';
import PropTypes from 'prop-types';

import RippleLoader from '@resources/svgs/ripple-loader.svg';

import styles from './Loader.scss';

const Loader = ({
  opaque,
  isPageLoader,
  children,
  size,
  isGlobal,
  className,
  'data-testid': dataTestId,
}) => {
  const loaderProps = cx(className, styles['component-loader'], {
    [styles['component-loader-opaque']]: opaque,
    [styles['component-loader-page']]: isPageLoader,
    [styles['component-loader--is-global']]: isGlobal,
  });

  const loaderIconProps = cx(styles['loader-icon'], [styles[`loader-icon--${size}`]]);

  return (
    <div className={loaderProps} data-testid={dataTestId}>
      <RippleLoader className={loaderIconProps} />
      {children && <span className={styles.componentLoaderText}>{children}</span>}
    </div>
  );
};

Loader.defaultProps = {
  children: '',
  opaque: false,
  isPageLoader: false,
  size: 'small',
  isGlobal: false,
  className: '',
  'data-testid': 'Loader',
};

Loader.propTypes = {
  children: PropTypes.any,
  opaque: PropTypes.bool,
  isPageLoader: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  isGlobal: PropTypes.bool,
  className: PropTypes.string,
  'data-testid': PropTypes.string,
};

export default Loader;
